// Projects data
const projectsData = [

    {
        id: 0,
        title: "Screensaved - Apple TV App",
        description: "Screensaved is a screensaver app for Apple TV that turns an idle TV into a useful display: full-screen wallpapers (gradients, aerial videos, personal photos) with glanceable widgets — clock, weather, Google Calendar & iCloud agenda, Spotify/Apple Music now-playing, upcoming releases, Steam activity.",
        techStack: ["Swift", "SwiftUI", "tvOS", "OAuth", "Spotify API", "Google Calendar API"],
        link: "https://screensaved.dylanca.dev"
    },
    {
        id: 1,
        title: "Apple Music - Rust Library | 20k+ downloads",
        description: "High-performance Rust library enabling programmatic control of local Apple Music player through native AppleScript integration. Provides a clean API for music playback automation and system integration.",
        techStack: ["Open Source", "Rust", "AppleScript", "macOS", "Systems Programming"],
        link: "https://github.com/dylanca/apple-music"
    },
    {
        id: 2,
        title: "Rust Discord Activity | 10k+ downloads",
        description: "Comprehensive Rust library for Discord Rich Presence integration, enabling applications to display custom activity status. Features robust IPC communication.",
        techStack: ["Open Source", "Rust", "Discord API", "IPC"],
        link: "https://github.com/dylanca/rust-discord-activity"
    },
    {
        id: 3,
        title: "KHFM-VF-Patch | 50k+ downloads",
        description: "Community-driven localization patch for Kingdom Hearts Final Mix, enabling French language support on PC platforms. Contributed Steam platform compatibility and deployment infrastructure.",
        techStack: ["Open Source", "C#", "Steam API", "Game Modding", "Community Contribution"],
        link: "https://github.com/DylanCa/KHFM-VF-Patch"
    },
    {
        id: 4,
        title: "IdeaBoard API - Developer Platform",
        description: "Gamified platform for discovering and contributing to open-source projects with sophisticated GitHub integration. Features advanced scoring algorithms, real-time tracking, and comprehensive project analytics.",
        techStack: ["Ruby", "Rails", "Sidekiq", "Redis", "Docker", "GitHub API", "GraphQL", "PostgreSQL"],
        link: "https://github.com/DylanCa/ideaboard_api"
    },
    {
        id: 5,
        title: "Apple Music Discord Activity",
        description: "Lightweight desktop application that automatically syncs currently playing Apple Music tracks with Discord Rich Presence, providing seamless music sharing integration.",
        techStack: ["Rust", "Discord API", "System Integration", "Desktop Application"],
        link: "https://github.com/DylanCa/apple-music-discord-activity"
    },
    {
        id: 6,
        title: "PBAW - Python Battle.net API Wrapper",
        description: "Comprehensive Python library providing streamlined access to Blizzard's Battle.net API. Features robust error handling, rate limiting, and comprehensive game data retrieval capabilities.",
        techStack: ["Python", "REST API", "Rate Limiting", "Gaming APIs", "Developer Tools"],
        link: "https://github.com/DylanCa/PBAW"
    }
];

export default projectsData;